import {
  ChangeEventHandler, FormEventHandler, useRef, useState,
} from 'react'
import { useDispatch } from 'react-redux'
import { actions } from '../../StockAdjustmentInBatchState'
import { validTypes } from './AdjustmentInBatchForm.data'
import * as S from './AdjustmentInBatchForm.styles'
import ErrorMessage from 'src/components/ErrorMessage'

const errorMessage = 'É necessário definir um arquivo Excel (.xls, .xlsx) antes de proceder'

export default () => {
  const dispatch = useDispatch()
  const [file, setFile] = useState<File>()
  const [showError, setShowError] = useState<boolean>(false)
  const inputFileRef = useRef<HTMLInputElement | null>()

  const isValidFile = (testFile: File) => validTypes.includes(testFile.type)

  const clearFile = () => {
    setFile(undefined)
    if (inputFileRef.current) {
      inputFileRef.current.value = ''
    }
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = (event) => {
    event.preventDefault()
    const fileInput = event?.target?.files?.[0] as File

    if (!isValidFile(fileInput)) {
      setShowError(true)
      clearFile()
      return
    }

    setFile(fileInput)
    setShowError(false)
  }

  const onSubmit: FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault()

    if (!file) {
      return
    }

    dispatch(actions.submitAdjustmentFile(file))
    clearFile()
  }

  return (
    <S.Form onSubmit={onSubmit}>
      <S.Label htmlFor='file'>
        Arquivo Excel
        <S.Input
          onChange={handleChange}
          type='file'
          name='sheet'
          id='file'
          ref={(ref) => { inputFileRef.current = ref }}
        />
        {showError && <ErrorMessage message={errorMessage} />}
      </S.Label>
      <S.Submit type='submit' value='Enviar' disabled={!file} />
    </S.Form>
  )
}
